var _defs, _defs2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("figure", {
    className: "ie-non-standard-hero-shape"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "10 12 878.9 907",
    style: {
      enableBackground: "new 10 12 878.9 907"
    },
    xmlSpace: "preserve",
    className: "injected-svg js-svg-injector",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "firstShape",
    d: "M329.15,403.44c30.22-62,26.51-223.94,94.06-268.46C479,98.23,560.16,257,700.68,151.61c71.25-53.44,85.54,81,160.38,172.6C1008.5,504.74,881.5,639.14,825.35,686.6c-62.54,52.85-246.14,24.42-386.7,79.28S214.07,834,202.07,702C190.39,573.57,288.69,486.43,329.15,403.44Z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "secondShape"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#firstShape",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#secondShape)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "imageShape1",
    style: {
      overflow: "visible"
    },
    width: 900,
    height: 900,
    xlinkHref: "https://discord.bimash.com.np/assets/img/midai.png",
    transform: "matrix(0.9488 0 0 0.9488 25 53.1187)"
  }))), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "thirdShape",
    d: "M337.17,855.62c-7.81-35.46,42.38-43.95,63.66-52.44,24.39-9.74,135.86-48,192.58-52.52,64.22-5.13,190.21-26.84,160.46,35.34-19.76,41.3-51.47,64.52-87.63,62.33-46.36-2.81-101.56,4.39-150.8,44C448.53,946.08,450.93,865,412,868,372.28,871,340.79,872.08,337.17,855.62Z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "fourthShape"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#thirdShape",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 0)",
    clipPath: "url(#fourthShape)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "imageShape2",
    style: {
      overflow: "visible"
    },
    width: 900,
    height: 1000,
    xlinkHref: "https://discord.bimash.com.np/assets/img/midai.png",
    transform: "matrix(0.9488 0 0 0.9488 25 53.1187)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArt);
export default __webpack_public_path__ + "static/media/art.528adf4f385c29fe29e4e3a65aa5e7fe.svg";
export { ForwardRef as ReactComponent };